import { PricingSheet } from "../types";
import { addDays, differenceInDays } from "date-fns";

const isPricingSheetExpiring = (
  sheet:
    | PricingSheet
    | (Omit<PricingSheet, "id"> & {
        id: number;
        createdAt: Date;
      }),
) => {
  if (!sheet.to) {
    return false;
  }

  const diffInDays = differenceInDays(
    addDays(new Date(), 60),
    new Date(sheet.to),
  );
  return diffInDays <= 60 && diffInDays > 0;
};

export default isPricingSheetExpiring;
